import { Field } from "@progress/kendo-react-form";
import { FormRegion } from "../../../../components/formregion";
import { useDispatch, useSelector } from "react-redux";
import { Fragment } from "react";
import {
  setFormValue,
  timeIntervalsDDL,
} from "../../../../redux/slices/createdatasetpageslice";
import { CollapsableFormRegion } from "../../../../components/collapsableformregion";
import {
  FormCheckbox,
  FormDropDownList,
  FormInput,
  FormTextArea,
} from "../../../../forms/form-components";
import { Grid, GridColumn } from "@progress/kendo-react-grid";
import { getDataType } from "../../../../lib/utils";
import { current } from "@reduxjs/toolkit";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const ReviewStep = (props) => {
  //#region state

  const { formValues } = props;
  console.log("formValues", formValues);
  const dispatch = useDispatch();
  const pageState = useSelector((state) => state.createDatasetPage);
  const currentTheme = useSelector((state) => state.currentTheme);
  let columns = null;
  const { t } = useTranslation();

  //#endregion

  if (pageState.formValues.DatasetFields.length > 0) {
    columns = Object.keys(pageState.formValues.DatasetFields[0]).map((key) => ({
      field: key,
      title: key.charAt(0).toUpperCase() + key.slice(1), // Capitalize title
      width: 150, // Explicit width for each column
    }));
  }

  const updatedDatasetFields = pageState.formValues.DatasetFields.map(
    (field) => ({
      ...field,
      DataTypeId: getDataType(field.DataTypeId), // Call getDataType for DataTypeId field
    })
  );
  //#endregion

  let showNumberOfRows = false;
  if (
    pageState.formValues.CreateFrom == "fromfile" &&
    pageState.formValues.IsCheckedImportData == true
  )
    showNumberOfRows = true;

  if (
    pageState.formValues.CreateFrom == "fromdb" &&
    pageState.formValues.DatasetImportData == true
  )
    showNumberOfRows = true;

  return (
    <FormRegion>
      <div className="error-list" id="error-list">
        {pageState.error_lst.map((e) => (
          <div key={e.Code}>
            <span style={{ color: `${currentTheme.error}` }}>{e.Code}: </span>
            {e.Message}
          </div>
        ))}
      </div>
      <CollapsableFormRegion
        className="form-region-main"
        title={t("datasets.create.general")}
        open={pageState.formValues.GeneralOpen}
        onToggle={(e) =>
          dispatch(
            setFormValue({
              id: "GeneralOpen",
              value: !pageState.formValues.GeneralOpen,
            })
          )
        }
      >
        <div className="form-group form-group-1">
          <Field
            id={"DatasetName"}
            name={"DatasetName"}
            label={t("datasets.create.name2")}
            disabled
            component={FormInput}
          />
          <Field
            id={"DatasetTitle"}
            name={"DatasetTitle"}
            label={t("datasets.create.title2")}
            disabled
            component={FormInput}
          />
          <Field
            id={"DatasetDescriptionNoEdit"}
            name={"DatasetDescription"}
            label={t("datasets.create.description2")}
            disabled
            component={FormTextArea}
          />

          <div className="checkbox-list">
            {/* <Field
              id="DatasetIsAlertBase"
              name="DatasetIsAlertBase"
              label={"Is Alert Base"}
              checked={pageState.formValues.DatasetIsAlertBase}
              component={FormCheckbox}
              className={"mb30"}
              disabled
            /> */}

            {pageState.formValues.CreateFrom == "fromfile" && (
              <Field
                id="IsCheckedImportData"
                name="IsCheckedImportData"
                label={t("datasets.create.import")}
                checked={pageState.formValues.IsCheckedImportData}
                component={FormCheckbox}
                className={"mb30"}
                disabled
              />
            )}
            {pageState.formValues.CreateFrom == "fromdb" && (
              <Fragment>
                <Field
                  id="DatasetImportData"
                  name="DatasetImportData"
                  label={t("datasets.create.import")}
                  checked={pageState.formValues.DatasetImportData}
                  component={FormCheckbox}
                  className={"mb30"}
                  disabled
                />

                <Field
                  id="DatasetIsReccurent"
                  name="DatasetIsReccurent"
                  label={t("datasets.create.reccurent")}
                  checked={pageState.formValues.DatasetIsReccurent}
                  component={FormCheckbox}
                  className={"mb30"}
                  disabled
                />
              </Fragment>
            )}
          </div>

          {pageState.formValues.CreateFrom == "fromdb" && (
            <Field
              id={"DatasetReccursEvery"}
              name={"DatasetReccursEvery"}
              label={t("datasets.create.recurs2")}
              disabled
              component={FormDropDownList}
              data={timeIntervalsDDL}
              dataItemKey="Id"
              textField="Title"
              className="mb30"
            />
          )}
          {showNumberOfRows && (
            <div className="k-form-field">
              <label className="k-label k-text-disabled"> {t("datasets.create.numofrows")}</label>
              <div className="k-form-field-wrap">
                <input
                  disabled={true}
                  name="NumberOfRows"
                  id="NumberOfRows"
                  className="k-input k-input-md k-rounded-md k-input-solid"
                  value={pageState.formValues.NumberOfRows || ""}
                />
              </div>
            </div>
          )}
          {pageState.formValues.CreateFrom == "fromdb" && (
            <Fragment>
              <div className="k-form-field">
                <label className="k-label k-text-disabled">
                  {t("datasets.create.datasize")}
                </label>
                <div className="k-form-field-wrap">
                  <input
                    disabled={true}
                    name="DataSize"
                    id="DataSize"
                    className="k-input k-input-md k-rounded-md k-input-solid"
                    value={pageState.formValues.DataSize / 1024 || ""}
                  />
                </div>
              </div>
              <div className="k-form-field">
                <label className="k-label k-text-disabled">
                   {t("datasets.create.consumption")}
                </label>
                <div className="k-form-field-wrap">
                  <input
                    disabled={true}
                    name="RestOfConsumption"
                    id="RestOfConsumption"
                    className="k-input k-input-md k-rounded-md k-input-solid"
                    value={pageState.formValues.RestOfConsumption / 1024 || ""}
                  />
                </div>
              </div>
            </Fragment>
          )}
        </div>
      </CollapsableFormRegion>

      <CollapsableFormRegion
        className="form-region-main"
        title= {t("datasets.create.datasetfields")}
        open={pageState.formValues.FieldsOpen}
        onToggle={(e) =>
          dispatch(
            setFormValue({
              id: "DataSampleOpen",
              value: !pageState.formValues.FieldsOpen,
            })
          )
        }
      >
        <div className="dataset-grid">
          <Grid
            data={updatedDatasetFields}
            scrollable="scrollable"
            resizable={true} // Enable column resizing
            style={{ height: "400px" }}
          >
            {columns &&
              columns.map((col, idx) => (
                <GridColumn
                  key={idx}
                  field={col.field}
                  title={col.field === "DataTypeId" ? "DataType" : col.title}
                  width={col.width}
                />
              ))}
          </Grid>
        </div>
      </CollapsableFormRegion>
      <style>
        {`
            .datasets-page .form-region-container{
                margin-bottom:30px;
            }
            .datasets-page .form-region-container .form-region-root .header{
                margin-bottom:10px;
            }

            .datasets-page .form-region-container .dataset-grid{
                width : 100%;
                overflow-x:auto;
            }
            .datasets-page-form .k-form-field textarea#DatasetDescriptionNoEdit{
                height:50px !important;
            }

            .datasets-page .checkbox-list{
            display:flex;
            justify-content:space-between;
          }
              .datasets-page > .content .form-root  .k-form  .checkbox-list .k-form-field:nth-child(1){
                margin-top:32px;
          }
          .datasets-page .error-list{
              padding-bottom:20px;
              border-bottom:1px solid ${currentTheme.componentBorderColor};
              margin-bottom:15px;
          }
          
        `}
      </style>
    </FormRegion>
  );
};

export default ReviewStep;
